import { render, staticRenderFns } from "./LooxReview.vue?vue&type=template&id=2c11dea6&scoped=true"
import script from "./LooxReview.vue?vue&type=script&lang=js"
export * from "./LooxReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c11dea6",
  null
  
)

export default component.exports